module.exports = __webpack_public_path__ + "img/29415620_196477127626244_3250318472361541632_n.03150f78.jpg";